import { FlowVersion } from "src/api/flowTypes";
import { useCaseTemplateInputSchemaError } from "src/schema/schemaEditor/useCaseTemplateInputSchemaValidation";
import { useNodeRunState } from "src/store/runState/RunState";
import { useGraphStore } from "src/store/StoreProvider";

export const useInputSchemaError = (
  inputSchema: FlowVersion["input_schema"],
): boolean => {
  const caseTemplateInputSchemaError =
    useCaseTemplateInputSchemaError(inputSchema);
  const { inputNode } = useGraphStore();
  const runStateCache = useNodeRunState(inputNode?.id ?? "");
  const inputRunState = inputNode ? runStateCache : undefined;

  return (
    caseTemplateInputSchemaError === "archived" ||
    caseTemplateInputSchemaError === "corrupted" ||
    inputRunState?.type === "historical-error" ||
    (inputRunState?.type === "test-run" &&
      inputRunState?.testResult.failure_count > 0)
  );
};

export const useOutputSchemaError = (): boolean => {
  const { outputNode } = useGraphStore();
  const runStateCache = useNodeRunState(outputNode?.id ?? "");
  const outputRunState = outputNode ? runStateCache : undefined;
  return (
    outputRunState?.type === "historical-error" ||
    (outputRunState?.type === "test-run" &&
      outputRunState?.testResult.failure_count > 0)
  );
};
